import i18n from '../../i18n';

interface DailyCleanedArea {
  days: DayArea[];
  years: number[];
}

export interface DayArea {
  date: string; // iso string
  cleanedArea: number;
}

export default DailyCleanedArea;

export interface ColorRule {
  color: string;
  fromValue: number;
  title: string;
}

export const dailyCleanedAreaColorRules = [
  {
    color: '#eeeeee',
    fromValueMetric: 0,
    fromValueImperial: 0,
    titleMetric: i18n.t('label-no-data'),
    titleImperial: i18n.t('label-no-data'),
  },
  {
    color: '#336699',
    fromValueMetric: 1,
    fromValueImperial: 1,
    titleMetric: '1 - 500',
    titleImperial: '1 - 5500',
  },
  {
    color: '#70B1D4',
    fromValueMetric: 500,
    fromValueImperial: 5500,
    titleMetric: '500 - 1000',
    titleImperial: '5500 - 10750',
  },
  {
    color: '#A1E1CF',
    fromValueMetric: 1000,
    fromValueImperial: 10750,
    titleMetric: '1000 - 2000',
    titleImperial: '10750 - 21500',
  },
  {
    color: '#BDF7B7',
    fromValueMetric: 2000,
    fromValueImperial: 21500,
    titleMetric: '2000 - 3000',
    titleImperial: '21500 - 32000',
  },
  {
    color: '#5FCF97',
    fromValueMetric: 3000,
    fromValueImperial: 32000,
    titleMetric: '3000 - 4000',
    titleImperial: '32000 - 43000',
  },
  {
    color: '#00A676',
    fromValueMetric: 4000,
    fromValueImperial: 43000,
    titleMetric: '4000+',
    titleImperial: '43000+',
  },
];

// mock data

export const mockDailyCleanedArea = {
  days: [
    { cleanedArea: 10, date: '2025-01-01' },
    { cleanedArea: 134, date: '2025-01-02' },
  ],
  years: [2025],
} as DailyCleanedArea;
